import ResignedEmployees from "../../../../components/company/workforce/resigned";

export default function ResignedEmployeesPage(){
    return <ResignedEmployees />
}